module.exports = window["wp"]["reusableBlocks"];